module.exports = __webpack_public_path__ + "img/productBanner.d79ab35a.jpg";